<script setup lang="ts">
import hOSAvatar from "@/components/hOSAvatar.vue";

type Person = {
  id: number;
  name: string;
  username: string;
  title?: string;
}

type Props = {
  person: Person;
  clickable?: boolean;
  isDirectManager?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  clickable: true,
  isDirectManager: false
});

const emit = defineEmits<{
  click: [username: string];
}>();

const handleClick = () => {
  if (props.clickable) {
    emit('click', props.person.username);
  }
};
</script>

<template>
  <div 
    class="group flex items-center gap-3 p-3 rounded-full border border-surface hover:bg-surface-50 hover:dark:bg-surface-950 transition-all relative"
    :class="{
    'cursor-pointer hover:shadow-md': clickable,
    'bg-yellow-50 dark:bg-yellow-950' : isDirectManager
    }"
    @click="handleClick"
  >
    <hOSAvatar :user="person" avatarClass="!w-10 !h-10" />
    <div class="flex flex-col flex-1 min-w-0">
      <div class="font-semibold text-sm truncate flex items-center gap-1">
        <i v-if="isDirectManager" class="pi pi-star-fill text-yellow-500 text-xs" v-tooltip.top="'Direct Manager'"></i>
        {{ person.name }}
      </div>
      <div v-if="person.title" class="text-xs text-muted-color truncate">{{ person.title }}</div>
    </div>
    <slot name="actions"></slot>
  </div>
</template>
